import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useOnboardingLens } from './onboardingLens';

interface OnboardingSelectionCounterProps {
  current: number;
  max: number;
}

/** Figma Semantic/Font/Number/Sm — selection counter; warning when limit reached. */
export function OnboardingSelectionCounter({ current, max }: OnboardingSelectionCounterProps) {
  const { t } = useTranslation();
  const { typography, typeMuted, statusWarningContent } = useOnboardingLens();
  const atLimit = current >= max;

  return (
    <Typography
      component="span"
      aria-live="polite"
      sx={{
        ...typography.numberSm,
        color: atLimit ? statusWarningContent : typeMuted,
        fontFeatureSettings: '"lnum" 1, "tnum" 1',
        flexShrink: 0,
        textAlign: 'right',
        whiteSpace: 'nowrap',
      }}
    >
      {atLimit
        ? t('onboarding.wizard.selection_limit_reached', { current, max })
        : t('onboarding.wizard.selection_count', { current, max })}
    </Typography>
  );
}
